import { PortfolioEditPriceRequest, PredictionCompanyResponse } from '../common/dto';
import { IPortfolioService } from './IPortfolioService';
import SftAuthService from './SftAuthService';
import { ChartData } from '@/domain/types';

export default class SftPortfolioService implements IPortfolioService {
  public static ApplicationPath = window.ApplicationPath;
  private isGuest = true;
  constructor(private auth: SftAuthService) {}

  public getLastPredictedSymbols() {
    return this.postCorsJSON('GetLastPredictedCompanies', { date: new Date().getTime() });
  }

  public refreshPortfolioCompaniesPrices() {
        return this.postCorsJSON('GetPortfolioCompaniesPrices', { date: new Date().getTime() });
  }

  public async getPortfolioSymbols() {
    const res = await this.postCorsJSON('GetPortfolioCompanies', { date: new Date().getTime() }) as any;

    if (res.Items) {
        res.Items = res.Items.filter((o: any) => !!o);
    }
    return res;
  }
  public deleteSymbol(symbolId: number) {
    return this.postCorsJSON('DeleteCompany', { companyId: symbolId });
  }
  public addSymbols(req: string[]) {
    return this.postCorsJSON('AddSymbols', {symbols: req});
  }

  public editSymbol(req: PortfolioEditPriceRequest) {
    return this.postCorsJSON('EditPortfolioSymbol', {req});
  }

  public recalculateSymbol(companyId: number, full: boolean) {
    return this.postCorsJSON('RecalculateFullCompany', { companyId, full });
  }

  public GetHistoryPrice(company: string, date: string) {
        return this.postCorsJSON('GetHistoryPrice', { symbol: company, dateString: date });
    }

  public GetCompaniesPrices() {
      return this.postCorsJSON('GetPortfolioCompaniesPrices', { ticks: new Date().getUTCMilliseconds() });
  }

  public GetQuote(company: string) {
    return this.postCorsJSON('GetCompanyRealtimeData', { symbol: company, extendedData: false });
  }
  public setSymbolEmailSetting(symbolId: number, val: boolean) {
    return this.postCorsJSON('SetCompanyEmailSetting', { companyId: symbolId, email: val });
  }



  public findSymbols(prefix: string) {
    const formData = new FormData();
    formData.append('value', prefix);

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open(
        'POST',
        window.ApplicationPath + '/WebServices/WebService.asmx/FindCompanies?' +
          'value=' + prefix +
          'dt=' + new Date().getTime(),
        true,
      );
      request.setRequestHeader('Accept', 'text/javascript, text/html, application/xml, text/xml, */*');
      request.setRequestHeader('contentType', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.withCredentials = true;
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          // We reached our target server, but it returned an error
          reject();
        }
      };

      request.onerror = () => {
        reject();
      };

      request.send();
    });

    // ($.ajax as any)({
    //     type: 'POST',
    //     cache: false,
    //     url: SftPortfolioService.ApplicationPath + '/WebServices/FindCompanies.aspx?value=' + prefix,
    //     contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    //     accepts:'text/javascript, text/html, application/xml, text/xml, */*',
    //     dataType: "json",
    //     crossDomain: true,
    //     xhrFields: {withCredentials: true},
    //     success: function (data:any, textStatus:any, jqXHR:any) {
    //         if (data.error) d.reject(); else d.resolve(data);
    //     },
    //     error: function () {
    //         d.reject();
    //     }
    // });
    // return d.promise();
  }
  public getCompanyPrice(company: string, sdate: Date) {
    // var d = $.Deferred();

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      // request.setRequestHeader('Accept', 'text/javascript, text/html, application/xml, text/xml, */*');
      request.open('POST', window.ApplicationPath + '/ForeCore/Portfolio/GetCompanyPrice', true);
      request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
      request.withCredentials = true;
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          // We reached our target server, but it returned an error
          reject();
        }
      };

      request.onerror = () => {
        reject();
      };

      request.send(JSON.stringify({ company, date: sdate }));
    });

    // ($.ajax as any)({
    //     type: 'POST',
    //     cache: false,
    //     data: JSON.stringify({company:company,date:sdate}),
    //     url: SftPortfolioService.ApplicationPath + '/ForeCore/Portfolio/GetCompanyPrice',
    //     contentType: 'application/json; charset=utf-8',
    //     dataType: "json",
    //     crossDomain: true,
    //     xhrFields: {withCredentials: true},
    //     success: (data:any, textStatus:any, jqXHR:any)=> {
    //         if (data.d.error) d.reject(); else d.resolve(data.d);
    //     },
    //     error: ()=>{
    //         d.reject();
    //     }
    // });
    // return d.promise();
  }

  // add them to common requests objs
  private addSessionParams(obj: any) {
    const t = this.auth.getSessionParams();
    obj.sessionid = t.sessionid;
    obj.loggedin = t.loggedin;
    return obj;
  }

  private postCorsJSON(method: string, params: object) {
    if (typeof params !== 'object') {
      throw new Error('params should be obj' + params);
    }

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', window.ApplicationPath + '/WebServices/WebService.asmx/' + method, true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
      request.withCredentials = true;
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          // We reached our target server, but it returned an error
          reject();
        }
      };

      request.onerror = () => {
        reject();
      };

      request.send(JSON.stringify(params));
    });


  }
}
